import { createReducer } from "@reduxjs/toolkit";
import {
  deleteCategoriesBulkAsync,
  deleteCategoryAsync,
  deleteCategorySuccess,
  getCategoryListSuccess,
  LoadingData,
  loadingList,
  saveCategoryListSuccess,
} from "./categoryActions";

export interface ICategoryState {
  categoryList: Array<any>;
  dataCount: number;
  isLoading: boolean;
}

const initialState: ICategoryState = {
  categoryList: [],
  dataCount: 0,
  isLoading: false,
};

export const categoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(getCategoryListSuccess, (state, action) => {
      state.categoryList = action.payload?.data ?? [];
      state.dataCount = action.payload?.dataCount ?? 0;
    })
    .addCase(saveCategoryListSuccess, (state, action) => {
      state.categoryList = action.payload;
    })
    .addCase(loadingList, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(deleteCategoryAsync.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.categoryList = state.categoryList.filter(
          (item) => String(item.id) !== String(action.payload.id)
        );
        state.dataCount = Math.max(0, state.dataCount - 1);
      }
    })
    .addCase(deleteCategoriesBulkAsync.fulfilled, (state, action) => {
      const { ids, failedIds = [] } = action.payload;

      // Only delete the IDs that were NOT in the failed list
      const successfullyDeletedIds = ids.filter(id => !failedIds.includes(id));

      state.categoryList = state.categoryList.filter(
        (item) => !successfullyDeletedIds.includes(item.id)
      );

      state.dataCount = Math.max(0, state.dataCount - successfullyDeletedIds.length);
    });

});